import React from "react";
import { HashLink as Link } from "react-router-hash-link";
import Home from "./Home";

// import video5 from ".//img/elephant.mov";

class Project3 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
    };
  }

  toggleExpand = () => {
    this.setState((prevState) => ({
      expanded: !prevState.expanded,
    }));
  };
  render() {
    const { expanded } = this.state;
    return (
      <div className="Project3">
        <div id="workdescription"></div>
        <>
          <div className="ButtonMenu">
            <Link to="../Home#about">
              <button className="Menu">&#60;About&#62;</button>
            </Link>
            <Link to="../Home#work">
              <button className="Menu">&#60;Work&#62;</button>
            </Link>
            <button>
              <Link to="../Home#contact" className="Menu">
                &#60;Contact&#62;
              </Link>
            </button>
          </div>
        </>

        <div className="workbody2">
          <img
            src="/img/bless1.gif"
            alt="prayimg animation"
            className="blessgifs"
          />
          <img
            src="/img/bless2.gif"
            alt="prayimg animation"
            className="blessgifs"
          />
          <img
            src="/img/bless3.gif"
            alt="prayimg animation"
            className="blessgifs"
          />
        </div>
        <div className="galleryplacement">
          <div id="workdescription2">
            {" "}
            <h4>
              BLESS CURSOR- <br />
              <span className="h2description"> Now your files are saved. </span>
            </h4>
            <section id="projecttext">
              <div className={`projecttext2 ${expanded ? "expanded" : ""}`}>
                {/* <h2>[INFO]</h2> */}
                <p>
                  To use on MAC: download the .tiff file and use Mousecape to
                  install. <br /> To use on WIN: download the .cur file, open
                  the cursor settings, click on customize pointer image, select
                  the .cur file. <br /> <br />
                </p>
              </div>
              {/* <button className="expand-btn" onClick={this.toggleExpand}>
                {expanded ? "[INFO] -" : "[INFO] + "}
              </button> */}
            </section>
            <div className="workbody2">
              {" "}
              <a class="links2" href="/cursorbless.tiff" download>
                [DOWNLOAD CURSOR - TIFF]
              </a>{" "}
              <a class="links2" href="/cursorbless.cur" download>
                [DOWNLOAD CURSOR - CUR]
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Project3;
